// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ProvidersOut = zod.object({
  "entra": zod.boolean()
});

export type ProvidersOut = zod.input<typeof ProvidersOut>;
export type ProvidersOutOutput = zod.output<typeof ProvidersOut>;
